export default __webpack_public_path__ + "static/media/WingspanAI_logo_temp.8d7fc68c.svg";